/* eslint-disable */
import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import VillageList from './VillageList';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import { getAllVillageDistricts, getAllVillageTalukas, addVillageData, getVillageData, editVillage, resetVillage, resetVillageList } from '../actions/masterManagementAction';
import { SET_ALL_TALUKA } from '../../../common/constants/ActionTypes';

const VillageForm = ({ addVillage, setAddVillage, setVillageState, setVillageDistrict, setVillageTaluka, villageArea, villageCode, villagePincode, villageName, villageState, villageTaluka, villageDistrict, setVillageCode, setVillageName, setVillagePincode, setVillagelevels, setVillageArea, setVillageAdminBlock, setVillageGrampanchayat }) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange"
  });
  const onSubmit = (data, addVillage, setAddVillage) => {
    let requestBody = {
      "village": {
        "name": data.villageName,
        "subdistrictcode": villageTaluka,
        "uniquecode": villageState + villageDistrict + '0' + villageTaluka,
        "adminblock": data.adminBlock,
        "grampanchayat": data.grampanchayat,
        "pincode": data.pincode,
        "levels": data.area == 'Rural' ? "Village" : null,
        "grampanchayatcode": null,
        "area": data.area,
        "isActive": data.isActive,
        "isDeleted": false
      }
    };
    dispatch(resetVillageList());
    if (addVillage.Mode == 'Add') {
      dispatch(addVillageData(requestBody, setAddVillage, setVillageState, setVillageDistrict, setVillageTaluka, setVillageName));
    }
    else if (addVillage.Mode == 'Edit') {
      requestBody.village.code = addVillage.villageCode;
      requestBody.village.subdistrictcode = addVillage.villageTaluka;
      requestBody.village.pincode = addVillage.villagePincode;
      requestBody.village.levels = addVillage.villageLevels;
      requestBody.village.adminblock = addVillage.villageAdminBlock;
      requestBody.village.grampanchayatcode = addVillage.villageGrampanchayatCode;
      requestBody.village.uniquecode = addVillage.villageUniquecode;
      requestBody.village.area = addVillage.villageArea;
      dispatch(editVillage(requestBody, setAddVillage, setVillageState, setVillageDistrict, setVillageTaluka, setVillageName));
    }
  }

  useEffect(() => {
    if (addVillage && addVillage.Mode == 'Add') {
      dispatch(resetVillageList());
      setVillageState(false);
      setVillageDistrict(false);
      setVillageTaluka(false);
      setVillageArea(false);
      setVillageName('');
      setVillagePincode('');
      // setVillagelevels('');
      // setVillageAdminBlock('');
      // setVillageGrampanchayat('');

    }

    addVillage.Mode == "Edit" && addVillage.villageCode > 0 && dispatch(getVillageData(addVillage.villageCode));
    addVillage.Mode == "Edit" && addVillage.villageCode > 0 && dispatch(getAllVillageDistricts(addVillage.villageState));
    addVillage.Mode == "Edit" && addVillage.villageCode > 0 && dispatch(getAllVillageTalukas(addVillage.villageDistrict));
    addVillage.Mode == "Edit" && addVillage.villageCode > 0 && setVillageState(addVillage.villageState);
    addVillage.Mode == "Edit" && addVillage.villageCode > 0 && setVillageDistrict(addVillage.villageDistrict);
    addVillage.Mode == "Edit" && addVillage.villageCode > 0 && setVillageTaluka(addVillage.villageTaluka);
    addVillage.Mode == "Edit" && addVillage.villageCode > 0 && setVillagePincode(addVillage.villagePincode);
    dispatch({
      type: SET_ALL_TALUKA,
      payload: {},
    });
    // eslint-disable-next-line
  }, [])
  const onAreaChange = (e) => {
    setVillageArea(e.target.value);
    let areaVal = e.target.value;
    let levelVal = areaVal == 'Rural' ? "Village" : null;
    // setVillagelevels(levelVal);
  };
  const onVillageStateChange = (e) => {
    dispatch(resetVillage());
    dispatch(resetVillageList());
    let villageSelectedState = e.target.value;
    setVillageState(villageSelectedState);
    setVillageDistrict(false);
    setVillageTaluka(false);
    dispatch(getAllVillageDistricts(villageSelectedState));
  }
  const onDistrictChange = (e) => {
    dispatch(resetVillageList());
    let villageSelectedDistrict = e.target.value;
    setVillageDistrict(villageSelectedDistrict);
    setVillageTaluka(false);
    dispatch(getAllVillageTalukas(villageSelectedDistrict));
  }
  const onTalukaChange = (e) => {
    dispatch(resetVillageList());
    let villageSelectedTaluka = e.target.value;
    setVillageTaluka(villageSelectedTaluka);
  }
  const onPincodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setVillagePincode(value)

  }

  const { villageStatesList, villageDistrictsList, villageTalukasList, villageDetails } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  const onCancelButton = () => {
    setAddVillage({ "Mode": false });
    dispatch(resetVillageList());
    setVillageState(false);
    setVillageDistrict(false);
    setVillageTaluka(false);
    setVillageArea(false);
    setVillageName('');
    setVillagePincode('');
    // setVillagelevels('');
    // setVillageAdminBlock('');
    // setVillageGrampanchayat('');
  }


  return addVillage.Mode == false ? (
    <div>
      <VillageList
        setAddVillage={setAddVillage}
      />
    </div>
  ) : (
    <div>
      <form>
        <div className="border border-light text-center w-100 p-5" >
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-6'>
                <h4><p className='float-left'>{addVillage.Mode == 'Add' ? masterLabels.villageForm.Add_Village : masterLabels.villageForm.Update_Village}</p></h4>
              </div>
            </div>
          </div>
          <br />
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-2'>
                <label className="float-left font-weight-bold">{masterLabels.villageForm.States}<span className="redColor">*</span></label>
                <select
                  className='form-control mt-1'
                  name="villageState"
                  value={villageState}
                  onInput={onVillageStateChange}
                  ref={register({ required: true })}
                  defaultValue={addVillage && addVillage.Mode == 'Edit' && addVillage.villagestate}
                  disabled={addVillage && addVillage.Mode == 'Edit' && true}
                >

                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {villageStatesList && villageStatesList.stateDtoList && villageStatesList.stateDtoList.length > 0 && villageStatesList.stateDtoList.map((element, index) =>
                    <option key={index} value={element.code}>{element.name}</option>
                  )}
                </select>
                {_.get("villageState.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
              </div>

              <div className='col-md-2'>
                <label className="float-left font-weight-bold">{masterLabels.villageForm.Districts}<span className="redColor">*</span></label>
                <select
                  className='form-control mt-1'
                  name="villageDistrict"
                  value={villageDistrict}
                  onInput={onDistrictChange}
                  ref={register({ required: true })}
                  defaultValue={addVillage && addVillage.Mode == 'Edit' && addVillage.villageDistrict}
                  disabled={(addVillage && addVillage.Mode == 'Edit') && true}
                >

                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {villageDistrictsList && villageDistrictsList.districtList && villageDistrictsList.districtList.length > 0 && villageDistrictsList.districtList.map((element, index) =>
                    <option key={index} value={element.code}>{element.name}</option>
                  )}
                </select>

                {_.get("villageDistrict.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}

              </div>
              <div className='col-md-2'>
                <label className="float-left font-weight-bold">{masterLabels.villageForm.Talukas}<span className="redColor">*</span></label>
                <select
                  className='form-control mt-1'
                  name="villageTaluka"
                  value={villageTaluka}
                  onInput={onTalukaChange}
                  ref={register({ required: true })}
                  defaultValue={addVillage && addVillage.Mode == 'Edit' && addVillage.villageTaluka}
                  disabled={(addVillage && addVillage.Mode == 'Edit') && true}
                >

                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {villageTalukasList && villageTalukasList.talukaDtoList && villageTalukasList.talukaDtoList.length > 0 && villageTalukasList.talukaDtoList.map((element, index) =>
                    <option key={index} value={element.code}>{element.name}</option>
                  )}
                </select>

                {_.get("villageDistrict.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}

              </div>
              <div className='col-md-3'>
                <label className='font-weight-bold float-left' >{masterLabels.villageForm.Village_Name}<span className="redColor">*</span></label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="villageName"
                  placeholder={masterLabels.villageForm.Village_Name}
                  ref={register({ required: true, maxLength: 50 })}
                  defaultValue={addVillage && addVillage.Mode == 'Edit' && addVillage.villageName ? addVillage.villageName : ''}
                  onChange={(event) => setVillageName(event.target.value)}
                />
                {_.get("villageName.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("villageName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_50}</p>
                )}
              </div>
              <div className='col-md-3'>
                <label className='font-weight-bold float-left' >{masterLabels.villageForm.GramPanchayat}</label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="grampanchayat"
                  placeholder={masterLabels.villageForm.GramPanchayat}
                  ref={register({ maxLength: 50 })}
                  defaultValue={addVillage && addVillage.Mode == 'Edit' && villageDetails && villageDetails.village && villageDetails.village.grampanchayat ? villageDetails.village.grampanchayat : ''}
                // onChange={(event) => setVillageGrampanchayat(event.target.value)}
                />

                {_.get("grampanchayat.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_50}</p>
                )}
              </div>
              <div className='col-md-3'>
                <label className='font-weight-bold float-left' >{masterLabels.villageForm.Admin_Block}</label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="adminBlock"
                  placeholder={masterLabels.villageForm.Admin_Block}
                  ref={register({ maxLength: 30 })}
                  defaultValue={addVillage && addVillage.Mode == 'Edit' && villageDetails && villageDetails.village && villageDetails.village.adminblock ? villageDetails.village.adminblock : ''}
                  // onChange={(event) => setVillageAdminBlock(event.target.value)}
                  disabled={(addVillage && addVillage.Mode == 'Edit') && true}
                />

              </div>
              <div className='col-md-3'>
                <label className='font-weight-bold float-left' >{masterLabels.villageForm.Pincode}</label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="pincode"
                  maxLength="6"
                  value={villagePincode}
                  onChange={onPincodeChange}
                  placeholder={masterLabels.villageForm.Pincode}
                  ref={register({ maxLength: 6 })}
                  defaultValue={addVillage && addVillage.Mode == 'Edit' && villageDetails && villageDetails.village && villageDetails.village.pincode ? villageDetails.village.pincode : ''}

                  disabled={(addVillage && addVillage.Mode == 'Edit') && true}
                />

                {_.get("pincode.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_6}</p>
                )}
              </div>

              <div className='col-md-2'>
                <label className="float-left font-weight-bold">{masterLabels.villageForm.Area}<span className="redColor">*</span></label>
                <select
                  className='form-control mt-1'
                  name="area"
                  ref={register({ required: true })}
                  onInput={onAreaChange}
                  defaultValue={addVillage && addVillage.Mode == 'Edit' && addVillage.villageArea}

                >

                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  <option key={1} value='Urban'>Urban</option>
                  <option key={2} value='Rural'>Rural</option>

                </select>
                {_.get("area.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}

              </div>
              <div className='col-md-1'>
                <label className='float-left font-weight-bold text-left w-100'>{masterLabels.villageForm.Village_Status}?&nbsp;&nbsp;</label>
                <input
                  className='float-left text-left'
                  type="checkbox"
                  name="isActive"
                  value={true}
                  defaultChecked={villageDetails && villageDetails.village && villageDetails.village.isActive}
                  ref={register({})}
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className='col-md-10'></div>
              <div className='col-md-2 text-right'>
                <button type="button" className="btn btn-secondary mr-2" onClick={() => onCancelButton()}>
                  {commonLabels.BUTTON_CANCEL}
                </button>
                <button type="submit" className=" btn btn-primary custom_button   " onClick={handleSubmit((e) => { onSubmit(e, addVillage, setAddVillage); })}>
                  {commonLabels.BUTTON_SAVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

  )
}

export default VillageForm;